import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            内容分类导航
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按主题浏览91c的丰富内容，快速找到您需要的信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 hover:shadow-sm transition-all duration-300 text-center"
            >
              <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-full bg-accent-50 text-accent-600 group-hover:bg-accent-100 transition-colors duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-400 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <p className="mt-2 text-xs text-foreground-300">
                {cat.count} 篇文章
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}